<template>
  <div class="container">   
    <Intro />       
    <BlogList />        
  </div>
</template>

<script>
import BlogList from '@/components/BlogList'
import Intro from '@/components/Intro'
export default {
  components: {BlogList, Intro},
  name: 'home',
  created(){
    //set active tab
    this.$store.commit('setCurrentTab', this.$options.name);
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue